import { useState } from 'react';
import { qd, apiError } from './api';

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState('');
  const [nw, setNw] = useState('');
  const [msg, setMsg] = useState(null);

  const submit = async () => {
    setMsg(null);
    if (nw.length < 8) { setMsg({ err: true, t: 'New password must be at least 8 characters.' }); return; }
    try {
      await qd.post('/auth/change-password', { current_password: cur, new_password: nw });
      setMsg({ err: false, t: 'Password changed.' });
      setCur(''); setNw('');
      setTimeout(() => { setOpen(false); setMsg(null); }, 1500);
    } catch (e) { setMsg({ err: true, t: apiError(e) }); }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className="text-xs text-slate-400 hover:text-white mb-2 block" data-testid="qd-change-pw-btn">
        Change password
      </button>
    );
  }
  return (
    <div className="mb-3 space-y-1.5" data-testid="qd-change-pw-form">
      <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Current password"
        className="w-full bg-white/10 border border-white/20 rounded px-2 py-1.5 text-xs text-white placeholder:text-slate-400" data-testid="qd-pw-current" />
      <input type="password" value={nw} onChange={(e) => setNw(e.target.value)} placeholder="New password (min 8)"
        className="w-full bg-white/10 border border-white/20 rounded px-2 py-1.5 text-xs text-white placeholder:text-slate-400" data-testid="qd-pw-new" />
      <div className="flex gap-2">
        <button onClick={submit} className="bg-[#0F7D70] text-white text-xs px-2.5 py-1 rounded" data-testid="qd-pw-save">Save</button>
        <button onClick={() => { setOpen(false); setMsg(null); }} className="text-xs text-slate-400 hover:text-white">Close</button>
      </div>
      {msg && <p className={`text-[11px] ${msg.err ? 'text-red-400' : 'text-teal-300'}`} data-testid="qd-pw-msg">{msg.t}</p>}
    </div>
  );
};
